export default __webpack_public_path__ + "static/media/fr100.ed8c2582.webp";